export default __webpack_public_path__ + "static/escola-autoral-b37dbf9fcb064f777a583a6f9c6bd652.png";